import { FaSearch } from "react-icons/fa";
import { BsFillCartFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import { useContext, useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import CartContext from "../../context/CartContext";
import AuthContext from "../../context/authContext";
import SearchContext from "../../context/SearchContext";
import logo from "../../img/logo2.png";
import "./Navbar.css";

export default function Navbar() {
  const { cart } = useContext(CartContext);
  const { user, logoutUser } = useContext(AuthContext);
  const { setSearchTerm } = useContext(SearchContext);

  const [produtos, setProdutos] = useState([]); // todos os produtos
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [loading, setLoading] = useState(true); // loading enquanto carrega API

  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const location = useLocation();

  const totalItems = cart.length;

  // 1. Buscar produtos uma única vez ao montar componente
  useEffect(() => {
    const buscarProdutos = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://api.nwayami.com/api/produtos/");
        setProdutos(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        setLoading(false);
      }
    };
    buscarProdutos();
  }, []);

  // 2. Filtrar produtos localmente conforme o searchInput muda
  useEffect(() => {
    const termo = searchInput.toLowerCase().trim();

    if (!termo) {
      setSearchResults([]);
      setShowDropdown(false);
      setSearchTerm("");
      return;
    }

    const resultadosFiltrados = produtos.filter((product) => {
      const descricao = (product.descricao || "").toLowerCase();
      const marca = (product.marca || "").toLowerCase();
      const codigo = (product.codigo || "").toLowerCase();

      return (
        descricao.includes(termo) ||
        marca.includes(termo) ||
        codigo.includes(termo)
      );
    });

    setSearchResults(resultadosFiltrados);
    setShowDropdown(true);
    setSearchTerm(searchInput);
  }, [searchInput, produtos, setSearchTerm]);

  // 3. Limpa busca ao mudar de página
  useEffect(() => {
    setSearchInput("");
    setSearchResults([]);
    setSearchTerm("");
    setShowDropdown(false);
  }, [location.pathname, setSearchTerm]);

  // 4. Detectar clique fora da barra de busca para fechar dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setFadeOut(true);
        setTimeout(() => {
          setShowDropdown(false);
          setFadeOut(false);
        }, 200);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const clearSearch = () => {
    setSearchInput("");
    setSearchResults([]);
    setSearchTerm("");
    setShowDropdown(false);
  };

  return (
    <div>
      <nav className="navbar custom-navbar-top d-flex align-items-center p-1">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ width: "20vw", backgroundColor: "white" }}
        >
          <Link to={`/`}>
            <img src={logo} alt="Logo" className="img-fluid" style={{ height: "66px" }} />
          </Link>
        </div>

        <div className="position-relative flex-grow-1 mx-2">
          <div className="d-flex align-items-center bg-secondary rounded px-2 py-1">
            <FaSearch className="text-white" size={18} />
            <input
              ref={inputRef}
              type="text"
              placeholder="Buscar..."
              value={searchInput}
              onChange={handleInputChange}
              className="form-control border-0 bg-transparent text-white ms-2"
              style={{ fontSize: "14px", height: "32px" }}
            />
            {searchInput && (
              <AiOutlineClose
                size={18}
                onClick={clearSearch}
                style={{ cursor: "pointer", marginLeft: "8px", color: "#fff" }}
              />
            )}
          </div>

          {showDropdown && (
            <div
              ref={dropdownRef}
              className={`position-absolute bg-white w-100 mt-1 rounded shadow search-dropdown ${
                fadeOut ? "fade-out" : ""
              }`}
              style={{ zIndex: 999 }}
            >
              {loading ? (
                <div className="text-center py-3 d-flex justify-content-center align-items-center gap-2">
                  <div className="spinner-border text-secondary" role="status" />
                  <span className="text-muted">Carregando produtos...</span>
                </div>
              ) : searchResults.length > 0 ? (
                <ul className="list-group">
                  {searchResults.map((product) => (
                    <li key={product.id} className="list-group-item">
                      <Link
                        to={`/product/${product.id}`}
                        className="text-decoration-none text-dark"
                        onClick={clearSearch}
                      >
                        {product.descricao}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-center py-2 text-muted">Nenhum produto encontrado</div>
              )}
            </div>
          )}
        </div>

        <div className="d-flex align-items-center mx-3 position-relative">
          <Link to="/cart" className="text-dark position-relative">
            <BsFillCartFill size={26} />
            {totalItems > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: "12px" }}
              >
                {totalItems}
              </span>
            )}
          </Link>
        </div>

        <div className="d-flex align-items-center">
          {user ? (
            <>
              <Link to="/minha-conta" className="text-dark btn btn-outline-light ms-3">
                Minha Conta
              </Link>
              <button onClick={logoutUser} className="text-dark btn btn-outline-light ms-2">
                Sair
              </button>
            </>
          ) : (
            <Link to="/loginpage" className="text-dark btn btn-outline-light ms-3">
              Login
            </Link>
          )}
        </div>
      </nav>
    </div>
  );
}
